import { render, staticRenderFns } from "./DetailsPage_avatar.vue?vue&type=template&id=0311c232&scoped=true&"
import script from "./DetailsPage_avatar.vue?vue&type=script&lang=js&"
export * from "./DetailsPage_avatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0311c232",
  null
  
)

export default component.exports